module.exports = __webpack_public_path__ + "static/media/terms-of-use-network-ten.326d8716.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/terms-of-use-network-ten.pdf
// module id = 1511
// module chunks = 0